import { useRef, useMemo } from 'react';
function fingerprintValueObject(obj) {
  if (obj == null) return JSON.stringify(obj);
  var value = '';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = Object.keys(obj).sort()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;
      value = value.length ? "".concat(value, "::").concat(key, ":").concat(JSON.stringify(obj[key])) : "".concat(key, ":").concat(JSON.stringify(obj[key]));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return value;
}
/**
 * `equalValueObject` compares two simple objects for shallow equality.
 *
 * The objects are considered equal if they are the strictly equal,
 * or if all values on `a` are strictly equal to all values on `b`,
 * and vice-versa.
 *
 * Note that it expects objects that are composed of simple string keys
 * and primitive values (i.e., no object or array values).
 */

export function equalValueObject(a, b) {
  if (a === b) return true;
  if (a === null || b === null) return false;
  if (a === undefined || b === undefined) return false;
  if (Object.keys(a).length !== Object.keys(b).length) return false;
  return fingerprintValueObject(a) === fingerprintValueObject(b);
}
/**
 * `useValueObject` will always return the _first_ object it was called with
 * that is shallowly equal to each consecutive object it is called with.
 *
 * Note that it expects objects that are composed of simple string keys
 * and primitive values (i.e., no object or array values).
 *
 * For example, this is useful for accepting simple configuration objects
 * as props while avoiding recalculating other state or memoized values
 * that are derived from the configuration.
 */

function useValueObject(value, transform) {
  var fingerprintRef = useRef();
  var nextValue = useMemo(function () {
    return typeof transform === 'function' ? transform(value) : value;
  }, [transform, value]);
  var valueRef = useRef(nextValue);
  var nextId = fingerprintValueObject(nextValue);
  if (fingerprintRef.current !== nextId) {
    valueRef.current = nextValue;
    fingerprintRef.current = nextId;
  }
  return valueRef.current;
}
export default useValueObject;